<template>
  <div
    id="up-nav-sidebar-options"
    :class="[
      'sidebar-option__wrapper flex flex-col w-18 h-18 text-center justify-center !py-0 text-primary-50 font-normal relative [.is-prefix+&:not(.is-prefix)]:mt-auto',
      {
        'bg-alpha-b15 text-green-logo': isActive,
        'is-prefix': isPrefix,
        'cursor-pointer': !disabled,
        'opacity-40 pointer-events-none': disabled,
      },
    ]"
    @click="!disabled && emit('click')"
  >
    <slot name="options">
      <div
        :class="[
          'sidebar-option__tip w-1 h-7.5 bg-green-logo absolute rounded-r',
          { hidden: !isActive },
        ]"
      ></div>
      <div
        :class="[
          'sidebar-icon flex justify-center items-center my-3 min-h-7',
          { 'text-green-logo': isActive },
        ]"
      >
        <div
          class="flex flex-col justify-center items-center gap-2 hover:text-green-logo"
        >
          <div class="relative inline-block h-6 w-6">
            <Icon size="1.5rem" :name="iconName ?? ''" />
            <Icon
              v-if="showPremiumBadge"
              size="0.6rem"
              class="absolute -bottom-px left-4 w-3 h-3 text-secondary-400"
              name="360-icons:diamond-badge-outline"
            />
          </div>
          <p class="sidebar-option-text text-xs">
            {{ displayText }}
          </p>
        </div>
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  displayText?: string;
  iconName?: string;
  isActive?: boolean;
  isPrefix?: boolean;
  showPremiumBadge?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  click: [];
}>();
</script>
